var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("main-layout", [
    _c("img", {
      staticClass: "sideText",
      attrs: { src: require("@/assets/img/sideText.png") }
    }),
    _vm._v(" "),
    _c("div", { staticClass: "has-text-dark isPoppins homePage" }, [
      _c("div", { staticClass: "mainHeroContainer skewYneg" }, [
        _c("div", { staticClass: " topHomeDiv mainHero posRel skewYpos" }, [
          _c(
            "div",
            {
              staticClass: "container top-120 has-text-white absCenter topDiv"
            },
            [
              _c("div", { staticClass: "columns   is-vcentered " }, [
                _c("div", { staticClass: "column is-two-fifths" }, [
                  _c("div", { staticClass: "is-size-1 smart" }, [
                    _c("b", [
                      _vm._v("Smart Links"),
                      _c("br"),
                      _vm._v("Everyone will Remember")
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "top10" }, [
                    _c("span", { staticClass: "is-size-4" }, [
                      _vm._v("Call your audience to action effectively")
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "column has-text-centered ",
                    attrs: { "data-aos": "slide-right" }
                  },
                  [_c("div", [_c("get-started", { ref: "gs" })], 1)]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "top30" }, [
                _c("div", { staticClass: "slider" }, [
                  _c("div", { staticClass: "top20 has-text-left" }, [
                    _c(
                      "div",
                      {
                        staticClass: "is-size-4 is-inline-block has-text-white"
                      },
                      [_c("b", [_vm._v("Share your")])]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "sliderBG is-inline-block" }, [
                      _c("div", { staticClass: "posRel topAdjust" }, [
                        _c(
                          "div",
                          { attrs: { "data-delay": "1200", id: "dataWords" } },
                          [
                            _c("span", { staticClass: "text-anim-items" }, [
                              _c("span", { staticClass: "text-anim-item" }, [
                                _c("span", [_vm._v("Meeting ID")])
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "text-anim-item" }, [
                                _c("span", [_vm._v("Webpage")])
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "text-anim-item" }, [
                                _c("span", [_vm._v("Social Profile")])
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "text-anim-item" }, [
                                _c("span", [_vm._v("Payment Page")])
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "text-anim-item" }, [
                                _c("span", [_vm._v("Online Storage")])
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "text-anim-item" }, [
                                _c("span", [_vm._v("Affiliate Link")])
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "text-anim-item" }, [
                                _c("span", [_vm._v("Landing Page")])
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "text-anim-item" }, [
                                _c("span", [_vm._v("Email")])
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "text-anim-item" }, [
                                _c("span", [_vm._v("Phone Number")])
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "text-anim-item" }, [
                                _c("span", [_vm._v("Photo Album")])
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "text-anim-item" }, [
                                _c("span", [_vm._v("Music Playlist")])
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "text-anim-item" }, [
                                _c("span", [_vm._v("Post")])
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "text-anim-item" }, [
                                _c("span", [_vm._v("Location")])
                              ])
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "anim-line" })
                          ]
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        " is-size-4 has-text-white has-text-left  mobileTop5"
                    },
                    [
                      _c("b", [
                        _vm._v("with an easy to say "),
                        _c(
                          "span",
                          {
                            staticClass: "has-text-yell has-text-weight-normal"
                          },
                          [_vm._v("|")]
                        ),
                        _vm._v(" easy to remember "),
                        _c("span", { staticClass: "is-size-3" }, [
                          _c("span", { staticClass: "has-text-white" }, [
                            _vm._v("s")
                          ]),
                          _c(
                            "span",
                            { staticClass: "has-text-weight-normal" },
                            [_vm._v("mart")]
                          ),
                          _vm._v(" "),
                          _c("span", { staticClass: "has-text-white" }, [
                            _vm._v("link")
                          ])
                        ])
                      ])
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "top30 " }, [
                  _c(
                    "button",
                    {
                      staticClass:
                        "button is-yell top1 has-text-primary left-5",
                      on: { click: _vm.goToHow }
                    },
                    [_c("b", [_vm._v("LEARN MORE")])]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "has-text-left" }, [
                  _c("img", {
                    staticClass: "chevDown handCursor",
                    attrs: {
                      src: require("@/assets/img/chevronTdown.png"),
                      width: "30"
                    },
                    on: { click: _vm.goToHow }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "is-hidden-desktop" }, [
                  _c("br"),
                  _c("br"),
                  _c("br"),
                  _c("br")
                ])
              ])
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "howWorksBG  skewYneg" }, [
        _c("div", { staticClass: "howWorksMid skewYpos" }, [
          _c(
            "div",
            {
              ref: "how",
              staticClass: "has-text-white has-text-left howWorks container"
            },
            [
              _c("div", {}, [
                _c("div", { staticClass: "is-size-2 has-text-yell top80" }, [
                  _c("img", {
                    attrs: {
                      src: require("@/assets/img/chevronsT.png"),
                      width: "30"
                    }
                  }),
                  _c("b", { staticClass: "left3" }, [_vm._v("How it Works")])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "columns is-vcentered top20 left20" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "column is-three-fifths",
                        attrs: { "data-aos": "fade-right" }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "lgRoundTopRight verticalsContent" },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "vAlignTop is-size-2 has-text-turk"
                              },
                              [
                                _c("b", [_vm._v("1.")]),
                                _vm._v(" "),
                                _c(
                                  "b",
                                  { staticClass: "is-size-3 has-text-yell" },
                                  [_vm._v("Create your slink:  ")]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("br"),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "addSubs is-inline-block" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "is-size-4 is-inline-block" },
                                  [
                                    _c("b", [_vm._v("turn:")]),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "has-text-grey-light" },
                                      [
                                        _vm._v(
                                          "https://www.clothes-website.com?aff=xdd345"
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "top5" }, [
                                  _c("b", { staticClass: "is-size-4" }, [
                                    _vm._v("into:  ")
                                  ]),
                                  _c(
                                    "span",
                                    { staticClass: "has-text-turk is-size-3" },
                                    [_vm._v("slink.com/")]
                                  ),
                                  _c(
                                    "span",
                                    { staticClass: "has-text-yell is-size-3" },
                                    [_vm._v("fashion")]
                                  )
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "is-size-4 top20 howEach has-text-white"
                              },
                              [
                                _vm._v(
                                  "\n                                            You retain exclusive control over each slink word you reserve\n                                        "
                                )
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "top40 verticalsContent lgRoundBottomRight"
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "is-size-2 has-text-turk" },
                              [
                                _c("b", [_vm._v("2.")]),
                                _vm._v(" "),
                                _c(
                                  "b",
                                  { staticClass: "is-size-3 has-text-yell" },
                                  [_vm._v("Add Subslinks:  ")]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: " top5 is-vcentered" }, [
                              _c("br"),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "is-inline-block has-text-left   addSubs"
                                },
                                [
                                  _c("div", {}, [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "has-text-turk is-size-4"
                                      },
                                      [_vm._v("slink.com/")]
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "has-text-yell is-size-4"
                                      },
                                      [
                                        _vm._v("fashion"),
                                        _c(
                                          "span",
                                          { staticClass: "has-text-white" },
                                          [
                                            _c(
                                              "b",
                                              { staticClass: "has-text-turk" },
                                              [_vm._v(":")]
                                            )
                                          ]
                                        ),
                                        _c("b", [_vm._v("sale")])
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "top5" }, [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "turkLightText is-size-4"
                                      },
                                      [_vm._v("slink.com/")]
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "has-text-yell is-size-4"
                                      },
                                      [
                                        _vm._v("fashion"),
                                        _c(
                                          "span",
                                          { staticClass: "has-text-white" },
                                          [
                                            _c(
                                              "b",
                                              { staticClass: "has-text-turk" },
                                              [_vm._v(":")]
                                            )
                                          ]
                                        ),
                                        _c("b", [_vm._v("shoes")])
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "top5" }, [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "turkLightText2 is-size-4"
                                      },
                                      [_vm._v("slink.com/")]
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "has-text-yell is-size-4"
                                      },
                                      [
                                        _vm._v("fashion"),
                                        _c(
                                          "span",
                                          { staticClass: "has-text-white" },
                                          [
                                            _c(
                                              "b",
                                              { staticClass: "has-text-turk" },
                                              [_vm._v(":")]
                                            )
                                          ]
                                        ),
                                        _c("b", [_vm._v("men")])
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "top5" }, [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "turkLightText3 is-size-4"
                                      },
                                      [_vm._v("slink.com/")]
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "has-text-yell is-size-4"
                                      },
                                      [
                                        _vm._v("fashion"),
                                        _c(
                                          "span",
                                          { staticClass: "has-text-white" },
                                          [
                                            _c(
                                              "b",
                                              { staticClass: "has-text-turk" },
                                              [_vm._v(":")]
                                            )
                                          ]
                                        ),
                                        _c("b", [_vm._v("deals")])
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "top5" }, [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "turkLightText4 is-size-4"
                                      },
                                      [_vm._v("slink.com/")]
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "has-text-yell is-size-4"
                                      },
                                      [
                                        _vm._v("fashion"),
                                        _c(
                                          "span",
                                          { staticClass: "has-text-white" },
                                          [
                                            _c(
                                              "b",
                                              { staticClass: "has-text-turk" },
                                              [_vm._v(":")]
                                            )
                                          ]
                                        ),
                                        _c("b", [_vm._v("trends")])
                                      ]
                                    )
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "is-size-4 top20 howEach has-text-white"
                                },
                                [
                                  _vm._v(
                                    "\n                                                        Point each subslink to a different URL."
                                  ),
                                  _c("br"),
                                  _vm._v(" Anything that has a URL can be "),
                                  _c("b", { staticClass: "has-text-turk" }, [
                                    _vm._v("slinked")
                                  ]),
                                  _vm._v(
                                    ".\n                                                "
                                  )
                                ]
                              )
                            ])
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "column has-text-white is-size-4",
                        attrs: { "data-aos": "fade-down" }
                      },
                      [
                        _c("div", { staticClass: "checkMarks" }, [
                          _c("div", [
                            _c("i", {
                              staticClass:
                                "fa fa-check top10 has-text-yell right5"
                            }),
                            _vm._v(" Easy Recall")
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _c("i", {
                              staticClass:
                                "fa fa-check top10 has-text-yell right5"
                            }),
                            _vm._v(" Analytics")
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _c("i", {
                              staticClass:
                                "fa fa-check top10 has-text-yell right5"
                            }),
                            _vm._v(" Organization")
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _c("i", {
                              staticClass:
                                "fa fa-check top10 has-text-yell right5"
                            }),
                            _vm._v(" Simplification")
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _c("i", {
                              staticClass:
                                "fa fa-check top10 has-text-yell right5"
                            }),
                            _vm._v(" Branding")
                          ])
                        ])
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "top40", attrs: { "data-aos": "fade-left" } },
                  [
                    _c("div", { staticClass: "dot" }, [_vm._v(" ")]),
                    _vm._v(" "),
                    _c("div", { staticClass: "dot" }, [_vm._v(" ")]),
                    _vm._v(" "),
                    _c("div", { staticClass: "dot" }, [_vm._v(" ")]),
                    _vm._v(" "),
                    _c("div", { staticClass: "dot" }, [_vm._v(" ")])
                  ]
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "iconsDiv container " }, [
            _c("div", { staticClass: "has-text-grey-light is-size-4" }, [
              _c("b", [
                _vm._v("Used on every major podcasting and social platform:")
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "is-size-7" }, [
              _c("div", { staticClass: "is-inline-block has-text-centered" }, [
                _c("div", [
                  _c("img", {
                    staticClass: "marginAutod",
                    attrs: {
                      src: require("@/assets/img/googlePodcasts.png"),
                      width: "100"
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "has-text-grey" }, [
                  _vm._v("Google Podcasts")
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "is-inline-block  has-text-centered" }, [
                _c("img", {
                  attrs: { src: require("@/assets/img/spotify.png") }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "has-text-grey" }, [_vm._v("Spotify")])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "is-inline-block  has-text-centered" }, [
                _c("img", {
                  attrs: { src: require("@/assets/img/applePodcasts.png") }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "has-text-grey" }, [
                  _vm._v("Apple Podcasts")
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "is-inline-block has-text-centered left5" },
                [
                  _c("div", [
                    _c("img", {
                      attrs: { src: require("@/assets/img/overcast.png") }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "has-text-grey" }, [
                    _vm._v("Overcast")
                  ])
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "is-inline-block has-text-centered" }, [
                _c("div", [
                  _c("img", {
                    attrs: { src: require("@/assets/img/tiktok.png") }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "has-text-grey" }, [_vm._v("Tiktok")])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "is-inline-block has-text-centered" }, [
                _c("div", [
                  _c("img", {
                    attrs: { src: require("@/assets/img/insta.png") }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "has-text-grey" }, [
                  _vm._v("Instagram")
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "is-inline-block has-text-centered" }, [
                _c("div", [
                  _c("img", {
                    attrs: { src: require("@/assets/img/youtube.png") }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "has-text-grey" }, [_vm._v("YouTube")])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "is-inline-block has-text-centered" }, [
                _c("div", [
                  _c("img", {
                    attrs: { src: require("@/assets/img/linkedin.png") }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "has-text-grey" }, [
                  _vm._v("LinkedIn")
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "is-inline-block has-text-centered" }, [
                _c("div", [
                  _c("img", {
                    attrs: { src: require("@/assets/img/twitter.png") }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "has-text-grey" }, [_vm._v("Twitter")])
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "slantedDiv verticals " }, [
        _c("div", { staticClass: "container has-text-white" }, [
          _c(
            "div",
            { staticClass: "is-size-2 has-text-white has-text-left isPoppins" },
            [
              _c("img", {
                attrs: {
                  src: require("@/assets/img/chevronsY.png"),
                  width: "30"
                }
              }),
              _c("b", { staticClass: "left3" }, [_vm._v("Why use Slinks?")])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "verticalsContentMain top40",
              attrs: { "data-aos": "fade-left" }
            },
            [
              _c("div", { staticClass: "columns top20" }, [
                _c("div", { staticClass: "column verticalsColumn" }, [
                  _c("div", { staticClass: "is-size-3 vertTitle" }, [
                    _c("b", [_vm._v("Podcasts, Audio Ads, Influencers & OOH")])
                  ]),
                  _vm._v(" "),
                  _c(
                    "ul",
                    {
                      staticClass:
                        "top40 left20 is-size-5  panelText has-text-light"
                    },
                    [
                      _c("li", [
                        _vm._v(
                          "Overcome the difficulties in relaying an effective verbal or printed call to action"
                        )
                      ]),
                      _vm._v(" "),
                      _c("li", { staticClass: "top20" }, [
                        _vm._v(
                          "Track your verbal and printed calls to action with the same level analytics that click ads generate"
                        )
                      ]),
                      _vm._v(" "),
                      _c("li", { staticClass: "top20" }, [
                        _vm._v(
                          "Simplify affiliate links into logical, easy to remember urls"
                        )
                      ]),
                      _vm._v(" "),
                      _c("li", { staticClass: "top20" }, [
                        _vm._v(
                          "Leverage the SlinkPage to direct your audience to a listing of all your subslinks"
                        )
                      ]),
                      _vm._v(" "),
                      _c("li", { staticClass: "top20" }, [
                        _vm._v(
                          "Organize your calls to action into branded groups under your slink using subslinks:"
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "top30 left20 is-size-5 egs" }, [
                    _c("span", { staticClass: "has-text-yell" }, [
                      _c("b", [_vm._v("Eg:")])
                    ]),
                    _vm._v(" "),
                    _c("b", [_vm._v("gourmetshow")]),
                    _vm._v(" "),
                    _c("ul", { staticClass: "top5" }, [
                      _c("li", [
                        _c("span", { staticClass: "has-text-grey-light" }, [
                          _vm._v("gourmetshow")
                        ]),
                        _c("b", [_vm._v(":recipes")])
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c("span", { staticClass: "has-text-grey-light" }, [
                          _vm._v("gourmetshow")
                        ]),
                        _c("b", [_vm._v(":episodes")])
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c("span", { staticClass: "has-text-grey-light" }, [
                          _vm._v("gourmetshow")
                        ]),
                        _c("b", [_vm._v(":episode11")])
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c("span", { staticClass: "has-text-grey-light" }, [
                          _vm._v("gourmetshow")
                        ]),
                        _c("b", [_vm._v(":discounts")])
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c("span", { staticClass: "has-text-grey-light" }, [
                          _vm._v("gourmetshow")
                        ]),
                        _c("b", [_vm._v(":courses")])
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "column verticalsColumn" }, [
                  _c("div", { staticClass: "is-size-3 vertTitle" }, [
                    _c("b", [_vm._v("Brands & Agencies")])
                  ]),
                  _vm._v(" "),
                  _c(
                    "ul",
                    {
                      staticClass:
                        "top40 left20 is-size-5    panelText has-text-light"
                    },
                    [
                      _c("li", [
                        _vm._v(
                          'Leverage the benefits of controlling a category-defining word such as "music" or "fashion" and/or...'
                        )
                      ]),
                      _vm._v(" "),
                      _c("li", { staticClass: "top20" }, [
                        _vm._v(
                          "...Strengthen the power and recall of your brand by using it as the root for all your subslinks"
                        )
                      ]),
                      _vm._v(" "),
                      _c("li", { staticClass: "top20" }, [
                        _vm._v(
                          "Increase engagement by providing a friction-free, traffic enabler to your content"
                        )
                      ]),
                      _vm._v(" "),
                      _c("li", { staticClass: "top20" }, [
                        _vm._v(
                          "Consolidate analytics acrosss multiple media and run AB tests using different slinks or subslinks"
                        )
                      ]),
                      _vm._v(" "),
                      _c("li", { staticClass: "top20" }, [
                        _vm._v(
                          "Create directories of related links under a slink using subslinks:"
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "top20 left20 is-size-5  egs" }, [
                    _c("span", { staticClass: "has-text-yell" }, [
                      _c("b", [_vm._v("Eg:")])
                    ]),
                    _vm._v(" "),
                    _c("b", [_vm._v("fashion")]),
                    _vm._v(" "),
                    _c("ul", { staticClass: "top5" }, [
                      _c("li", [
                        _c("span", { staticClass: "has-text-grey-light" }, [
                          _vm._v("fashion")
                        ]),
                        _c("b", [_vm._v(":sale")])
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c("span", { staticClass: "has-text-grey-light" }, [
                          _vm._v("fashion")
                        ]),
                        _c("b", [_vm._v(":shoes")])
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c("span", { staticClass: "has-text-grey-light" }, [
                          _vm._v("fashion")
                        ]),
                        _c("b", [_vm._v(":men")])
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c("span", { staticClass: "has-text-grey-light" }, [
                          _vm._v("fashion")
                        ]),
                        _c("b", [_vm._v(":discounts")])
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c("span", { staticClass: "has-text-grey-light" }, [
                          _vm._v("fashion")
                        ]),
                        _c("b", [_vm._v(":trends")])
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "column verticalsColumn" }, [
                  _c("div", { staticClass: "is-size-3 vertTitle" }, [
                    _c("b", [_vm._v("Personal use")])
                  ]),
                  _vm._v(" "),
                  _c(
                    "ul",
                    {
                      staticClass:
                        "top40 left20 is-size-5   panelText has-text-light  "
                    },
                    [
                      _c("li", [
                        _vm._v(
                          "Virtually eliminate the typical obstacles in verbally relaying personal URLs like your email, a meeting ID, a payment page. Even turn your phone number into a slink"
                        )
                      ]),
                      _vm._v(" "),
                      _c("li", { staticClass: "top20" }, [
                        _vm._v(
                          "Make it easy for people to remember how to reach you without having to look up your info"
                        )
                      ]),
                      _vm._v(" "),
                      _c("li", { staticClass: "top20" }, [
                        _vm._v(
                          "Set up personal shortcuts for things like online storage folders, family photo albums, travel itineraries, food order lines, etc, so they can easily be reached from memory and from any device"
                        )
                      ]),
                      _vm._v(" "),
                      _c("li", { staticClass: "top20" }, [
                        _vm._v(
                          "Consolidate all your contact links under your slink using subslinks:"
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "top20 left20 is-size-5  egs" }, [
                    _c("span", { staticClass: "has-text-yell" }, [
                      _c("b", [_vm._v("Eg:")])
                    ]),
                    _vm._v(" "),
                    _c("b", [_vm._v("john")]),
                    _vm._v(" "),
                    _c("ul", { staticClass: "top5" }, [
                      _c("li", [
                        _c("span", { staticClass: "has-text-grey-light" }, [
                          _vm._v("john")
                        ]),
                        _c("b", [_vm._v(":zoom")])
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c("span", { staticClass: "has-text-grey-light" }, [
                          _vm._v("john")
                        ]),
                        _c("b", [_vm._v(":email")])
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c("span", { staticClass: "has-text-grey-light" }, [
                          _vm._v("john")
                        ]),
                        _c("b", [_vm._v(":phone")])
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c("span", { staticClass: "has-text-grey-light" }, [
                          _vm._v("john")
                        ]),
                        _c("b", [_vm._v(":calendar")])
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c("span", { staticClass: "has-text-grey-light" }, [
                          _vm._v("john")
                        ]),
                        _c("b", [_vm._v(":instagram")])
                      ])
                    ])
                  ])
                ])
              ])
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "has-text-left" }, [
            _c("img", {
              staticClass: "chevDown",
              attrs: {
                src: require("@/assets/img/chevronTdown.png"),
                width: "30"
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "top20 is-pulled-right" }, [
            _c("div", { staticClass: "dot" }, [_vm._v(" ")]),
            _vm._v(" "),
            _c("div", { staticClass: "dot" }, [_vm._v(" ")]),
            _vm._v(" "),
            _c("div", { staticClass: "dot" }, [_vm._v(" ")]),
            _vm._v(" "),
            _c("div", { staticClass: "dot" }, [_vm._v(" ")])
          ])
        ]),
        _vm._v(" "),
        _c("br"),
        _c("br"),
        _c("br"),
        _c("br")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "has-text-centered quote1 " }, [
        _c("div", { staticClass: "columns top60" }, [
          _c(
            "div",
            { staticClass: "column is-size-3 container is-hidden-mobile" },
            [_vm._v(" ")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "column is-size-3 container is-two-thirds has-text-right"
            },
            [
              _vm._v(
                '"Slinks are like vanity 1-800 numbers for the Internet, like QR codes that can be remembered, like a search term that points to only one result, '
              ),
              _c("b", [_vm._v("yours")]),
              _vm._v('"')
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "thePanels " }, [
        _c("div", {}, [
          _c("div", { staticClass: "columns" }, [
            _c(
              "div",
              {
                staticClass:
                  "column has-text-dark has-text-white is-four-fifths",
                attrs: { "data-aos": "slide-right" }
              },
              [
                _c("div", { staticClass: "columns " }, [
                  _c(
                    "div",
                    { staticClass: "column panelImg is-three-fifths" },
                    [
                      _c("img", {
                        staticClass: "is-pulled-right",
                        attrs: { src: require("@/assets/img/listener.png") }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "column" }, [
                    _c("div", { staticClass: "panelCol pullRight top-20" }, [
                      _c("br"),
                      _c("br"),
                      _c("br"),
                      _c("br"),
                      _vm._v(" "),
                      _c("div", [
                        _c("i", {
                          staticClass: "fa fa-check has-text-yell",
                          staticStyle: { "font-size": "120px" }
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "is-size-3 top10" }, [
                        _c("b", [
                          _vm._v(
                            "Bridge the gap between the physical and digital marketing worlds"
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "top40 panelText" }, [
                        _c("ul", { staticClass: "top40 is-size-4 " }, [
                          _c("li", [
                            _vm._v(
                              "Slinks are just as effective when relayed "
                            ),
                            _c("b", { staticClass: "has-text-turk" }, [
                              _vm._v("verbally, in print or as clickable links")
                            ])
                          ]),
                          _vm._v(" "),
                          _c("li", { staticClass: "top20" }, [
                            _vm._v("Get the "),
                            _c("b", { staticClass: "has-text-turk" }, [
                              _vm._v("same level of analytics")
                            ]),
                            _vm._v(
                              ' from verbal or printed calls to action as are available from "click ads"'
                            )
                          ]),
                          _vm._v(" "),
                          _c("li", { staticClass: "top20" }, [
                            _vm._v("Consolidate campaigns "),
                            _c("b", { staticClass: "has-text-turk" }, [
                              _vm._v("across different media")
                            ])
                          ]),
                          _vm._v(" "),
                          _c("li", { staticClass: "top20" }, [
                            _vm._v("Perform "),
                            _c("b", { staticClass: "has-text-turk" }, [
                              _vm._v("AB testing")
                            ]),
                            _vm._v(" using different slinks or subslinks")
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "column transBG is-hidden-mobile" })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "top10" }, [
          _c("div", { staticClass: "columns" }, [
            _c("div", { staticClass: "column is-hidden-mobile transBG " }, [
              _vm._v("\n                         \n                    ")
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "column panelTrans has-text-white is-four-fifths  ",
                attrs: { "data-aos": "slide-left" }
              },
              [
                _c("div", { staticClass: "columns" }, [
                  _c("div", { staticClass: "column is-two-fifths" }, [
                    _c(
                      "div",
                      { staticClass: "panelCol pullRight has-text-right" },
                      [
                        _c("br"),
                        _c("br"),
                        _c("br"),
                        _c("br"),
                        _vm._v(" "),
                        _c("img", {
                          attrs: {
                            src: require("@/assets/img/ownyourwordsyellow.png"),
                            width: "130"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: " top40" }, [
                          _c("div", { staticClass: "is-size-3 " }, [
                            _c("b", [
                              _vm._v("Confusion is a conversion killer")
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "top40 is-size-4" }, [
                            _c("ul", { staticClass: "top40 panelText " }, [
                              _c("li", [
                                _vm._v("Using a "),
                                _c("b", { staticClass: "has-text-yell" }, [
                                  _vm._v("simple, descriptive word")
                                ]),
                                _vm._v(
                                  " as the means through which users can access your content provides the path of least resistance to it"
                                )
                              ]),
                              _vm._v(" "),
                              _c("li", { staticClass: "top20" }, [
                                _vm._v("Having your content be "),
                                _c("b", { staticClass: "has-text-yell" }, [
                                  _vm._v(
                                    "exclusively associated with a category-defining word"
                                  )
                                ]),
                                _vm._v(
                                  ' such as "cars" or "music" lends instant credibility and top-of-mind advantage'
                                )
                              ]),
                              _vm._v(" "),
                              _c("li", { staticClass: "top30" }, [
                                _vm._v("Simplify your URLs, "),
                                _c("b", { staticClass: "has-text-yell" }, [
                                  _vm._v(
                                    "such as affiliate links, online meeting id links and payment pages"
                                  )
                                ])
                              ])
                            ])
                          ])
                        ])
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "column panelImg2  " }, [
                    _c("img", {
                      staticClass: "is-pulled-left ",
                      attrs: { src: require("@/assets/img/bulb.png") }
                    })
                  ])
                ])
              ]
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "top10" }, [
          _c("div", { staticClass: "columns" }, [
            _c(
              "div",
              {
                staticClass: "column  has-text-dark is-four-fifths ",
                attrs: { "data-aos": "slide-right" }
              },
              [
                _c("div", { staticClass: "columns" }, [
                  _c(
                    "div",
                    { staticClass: "column panelImg   is-three-fifths" },
                    [
                      _c("img", {
                        staticClass: "is-pulled-right  ",
                        attrs: { src: require("@/assets/img/embed.png") }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "column" }, [
                    _c("div", { staticClass: "panelCol pullRight" }, [
                      _c("br"),
                      _c("br"),
                      _c("br"),
                      _c("br"),
                      _vm._v(" "),
                      _c("img", {
                        attrs: {
                          src: require("@/assets/img/chevronsY.png"),
                          width: "160"
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: " top40" }, [
                        _c("div", { staticClass: "is-size-3 " }, [
                          _c("b", [
                            _vm._v(
                              "Embed your links into your audience’s memory"
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "top40 is-size-4" }, [
                          _c("ul", { staticClass: "top40 panelText " }, [
                            _c("li", [
                              _vm._v(
                                "The more memorable your call to action, "
                              ),
                              _c("b", { staticClass: "has-text-turk" }, [
                                _vm._v("the higher your chances of conversion")
                              ])
                            ]),
                            _vm._v(" "),
                            _c("li", { staticClass: "top20" }, [
                              _vm._v(
                                "Slinks remain in people's memory long after they see or hear them, "
                              ),
                              _c("b", { staticClass: "has-text-turk" }, [
                                _vm._v(
                                  "increasing the likelihood that they will be able to find your content over and over again,"
                                )
                              ]),
                              _vm._v(
                                "  without the need for a clickable link or a QR code in front of them"
                              )
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "column is-hidden-mobile transBG" }, [
              _vm._v("\n                         \n                    ")
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "has-text-left quote1" }, [
        _c("div", { staticClass: "is-size-3 container zQuote" }, [
          _vm._v("Increase your connectivity and availability with "),
          _c("b", [_vm._v("slinks")]),
          _vm._v(" and "),
          _c("b", [_vm._v("subslinks")])
        ]),
        _vm._v(" "),
        _c("br"),
        _vm._v(" "),
        _c("br"),
        _c("br")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "slantedDivMain has-background-textGrey" }, [
        _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "whatYouGet mobileMargin" }, [
            _c(
              "div",
              { staticClass: "is-size-2 has-text-white has-text-centered" },
              [
                _c("img", {
                  attrs: {
                    src: require("@/assets/img/chevronsY.png"),
                    width: "30"
                  }
                }),
                _c("b", { staticClass: "left3" }, [_vm._v("What you Get")])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "has-text-white is-size-5 wideLimitWidth marginAutod top60"
              },
              [
                _c("div", {}, [
                  _c("div", { staticClass: "top20" }, [
                    _c("span", { staticClass: "has-text-yell" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "is-inline-block vAlignTop is-size-4 has-text-yell"
                        },
                        [_c("b", [_vm._v("1.")]), _vm._v(" ")]
                      )
                    ]),
                    _vm._v("A "),
                    _c("b", [_vm._v("slink")]),
                    _vm._v(
                      " made up of a strong, descriptive word related to your brand, product or industry."
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "top20" }, [
                    _c("span", { staticClass: "has-text-yell" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "is-inline-block vAlignTop is-size-4 has-text-yell"
                        },
                        [_c("b", [_vm._v("2.")]), _vm._v(" ")]
                      )
                    ]),
                    _c("b", [_vm._v("Subslinks")]),
                    _vm._v(
                      " to add and organize additional smart links under your slink, streamlining your audience's access to your content"
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", {}, [
                  _c("div", { staticClass: "top20" }, [
                    _c("span", { staticClass: "has-text-yell" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "is-inline-block vAlignTop is-size-4 has-text-yell"
                        },
                        [_c("b", [_vm._v("3.")]), _vm._v(" ")]
                      )
                    ]),
                    _vm._v("A "),
                    _c("b", [_vm._v("SlinkPage")]),
                    _vm._v(
                      " for each slink, where you can list all your slink's subslinks:"
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "linksSubsContainer top20",
                      attrs: { "data-aos": "zoom-in-up" }
                    },
                    [
                      _c("div", { staticClass: "top20 lpSub main home" }, [
                        _c("div", { staticClass: "columns lpCols" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "is-inline-block isPoppins is-size-4 column is-one-third"
                            },
                            [
                              _c("img", {
                                attrs: {
                                  src: require("@/assets/img/chevronsY.png"),
                                  width: "18"
                                }
                              }),
                              _c("b", { staticClass: "left3" }, [
                                _vm._v("hits")
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "is-size-5 column" }, [
                            _c("div", { staticClass: "lpDescHome" }, [
                              _vm._v("Music promotion services - website")
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "is-size-6 left10" }, [
                          _vm._v("slink.com/"),
                          _c("b", [_vm._v("hits")])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "left20 top15 lpSub" }, [
                        _c("div", { staticClass: "columns lpCols" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "isPoppins is-size-4 column is-one-third"
                            },
                            [_vm._v(" "), _c("b", [_vm._v(":calendar")])]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "is-size-5 column" }, [
                            _c("div", { staticClass: "lpDescHome" }, [
                              _vm._v("Schedule a meeting with us")
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "is-size-6 left10" }, [
                          _vm._v("slink.com/hits"),
                          _c("b", [_vm._v(":calendar")])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "left20 top15 lpSub" }, [
                        _c("div", { staticClass: "columns lpCols" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "isPoppins is-size-4  column is-one-third"
                            },
                            [_vm._v(" "), _c("b", [_vm._v(":music")])]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "is-size-5  column" }, [
                            _c(
                              "div",
                              {
                                staticClass: "lpDescHome is-size-5",
                                attrs: { column: "" }
                              },
                              [_vm._v("Our catalog of releases")]
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "is-size-6 left10" }, [
                          _vm._v("slink.com/hits"),
                          _c("b", [_vm._v(":music")])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "left20 top15 lpSub" }, [
                        _c("div", { staticClass: "columns lpCols" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "isPoppins is-size-4  column is-one-third"
                            },
                            [_vm._v(" "), _c("b", [_vm._v(":email")])]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "is-size-5  column" }, [
                            _c(
                              "div",
                              {
                                staticClass: "lpDescHome is-size-5",
                                attrs: { column: "" }
                              },
                              [_vm._v("Email us for more information")]
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "is-size-6 left10" }, [
                          _vm._v("slink.com/hits"),
                          _c("b", [_vm._v(":email")])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "left20 top15 lpSub" }, [
                        _c("div", { staticClass: "columns lpCols" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "isPoppins is-size-4  column is-one-third"
                            },
                            [_vm._v(" "), _c("b", [_vm._v(":call")])]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "is-size-5  column" }, [
                            _c(
                              "div",
                              {
                                staticClass: "lpDescHome is-size-5",
                                attrs: { column: "" }
                              },
                              [_vm._v("Reach us by phone")]
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "is-size-6 left10" }, [
                          _vm._v("slink.com/hits"),
                          _c("b", [_vm._v(":call")])
                        ])
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "is-size-5 top20" }, [
                    _vm._v("Your "),
                    _c("b", [_vm._v("SlinkPage")]),
                    _vm._v(" can be reached with the subslink "),
                    _c("b", { staticClass: "has-text-yell" }, [
                      _vm._v(":links")
                    ]),
                    _vm._v(" or you can set it as your default slink URL")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "top20" }, [
                    _c("span", { staticClass: "has-text-yell" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "is-inline-block vAlignTop is-size-4 has-text-yell"
                        },
                        [_c("b", [_vm._v("4.")]), _vm._v(" ")]
                      )
                    ]),
                    _c("b", [_vm._v("A QR code generator")]),
                    _vm._v(
                      " that will create printable QR codes showing your slink or subslink below"
                    )
                  ])
                ])
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "is-size-3 has-text-white top160" }, [
            _c("img", {
              attrs: { src: require("@/assets/img/chevronsT.png"), width: "27" }
            }),
            _c("b", { staticClass: "left3" }, [_vm._v("Pricing")])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "has-text-yell is-size-4 top20" }, [
            _c("b", [_vm._v("Try 30 days for free")]),
            _vm._v(" (no credit card)")
          ]),
          _vm._v(" "),
          _vm.$root.showPlans
            ? _c(
                "div",
                {
                  staticClass: "columns top20 mobileMargin pricingBG",
                  attrs: { "data-aos": "fade-left" }
                },
                [
                  _c("div", { staticClass: "column top20" }, [
                    _c("div", { staticClass: "has-text-centered planPanel" }, [
                      _c("div", { staticClass: "planTitleHome" }, [
                        _c("b", [_vm._v("• BASIC •")])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "top40" }, [
                        _c("div", { staticClass: "is-size-3" }, [
                          _c("b", [
                            _vm._v("Slink + "),
                            _c("span", { staticClass: "has-text-yell" }, [
                              _vm._v(
                                _vm._s(_vm.$root.newPlans.SmallYearly.limit) +
                                  " subslinks"
                              )
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "is-size-6 top5" }, [
                          _c("b", [_vm._v("-")])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "is-size-6 top5" }, [
                          _c("b", [_vm._v("SlinkPage")])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "is-size-6 top5" }, [
                          _c("b", [_vm._v("QR codes")])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "is-size-6 top5" }, [
                          _vm._v("2 million redirects per year")
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "is-size-4 top40 priceContainer" },
                          [
                            _vm._v("$"),
                            _c("b", [
                              _vm._v(
                                _vm._s(_vm.$root.newPlans.SmallMonthly.price)
                              )
                            ]),
                            _vm._v("/mth "),
                            _c("br"),
                            _c("span", { staticClass: "is-size-6" }, [
                              _vm._v("or")
                            ]),
                            _c("br"),
                            _vm._v("$"),
                            _c("b", [
                              _vm._v(
                                _vm._s(_vm.$root.newPlans.SmallYearly.price)
                              )
                            ]),
                            _vm._v("/yr")
                          ]
                        ),
                        _vm._v(" "),
                        _c("br")
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "column top20" }, [
                    _c("div", { staticClass: "has-text-centered planPanel" }, [
                      _c("div", { staticClass: "planTitleHome" }, [
                        _c("b", [_vm._v("• PERSONAL •")])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "top40" }, [
                        _c("div", { staticClass: "is-size-3" }, [
                          _c("b", [
                            _vm._v("Slink + "),
                            _c("span", { staticClass: "has-text-yell" }, [
                              _vm._v(
                                _vm._s(_vm.$root.newPlans.MediumYearly.limit) +
                                  " subslinks"
                              )
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "is-size-6 top5" }, [
                          _c("b", [_vm._v("Analytics")])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "is-size-6 top5" }, [
                          _c("b", [_vm._v("SlinkPage")])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "is-size-6 top5" }, [
                          _c("b", [_vm._v("QR codes")])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "is-size-6 top5" }, [
                          _vm._v("3 million redirects per year")
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "is-size-4 top40 priceContainer" },
                          [
                            _vm._v("$$"),
                            _c("b", [
                              _vm._v(
                                _vm._s(_vm.$root.newPlans.MediumMonthly.price)
                              )
                            ]),
                            _vm._v("/mth "),
                            _c("br"),
                            _c("span", { staticClass: "is-size-6" }, [
                              _vm._v("or")
                            ]),
                            _c("br"),
                            _vm._v("$"),
                            _c("b", [
                              _vm._v(
                                _vm._s(_vm.$root.newPlans.MediumYearly.price)
                              )
                            ]),
                            _vm._v("/yr")
                          ]
                        ),
                        _vm._v(" "),
                        _c("br")
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "column top20" }, [
                    _c("div", { staticClass: "has-text-centered planPanel" }, [
                      _c("div", { staticClass: "planTitleHome" }, [
                        _c("b", [_vm._v("• PRO •")])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "top40" }, [
                        _c("div", { staticClass: "is-size-3" }, [
                          _c("b", [
                            _vm._v("Slink + "),
                            _c("span", { staticClass: "has-text-yell" }, [
                              _vm._v(
                                _vm._s(_vm.$root.newPlans.LargeYearly.limit) +
                                  " subslinks"
                              )
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "is-size-6 top5" }, [
                          _c("b", [_vm._v("Analytics")])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "is-size-6 top5" }, [
                          _c("b", [_vm._v("SlinkPage")])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "is-size-6 top5" }, [
                          _c("b", [_vm._v("QR codes")])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "is-size-6 top5" }, [
                          _vm._v("5 million redirects per year")
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "is-size-4 top40 priceContainer" },
                          [
                            _vm._v("$$"),
                            _c("b", [
                              _vm._v(
                                _vm._s(_vm.$root.newPlans.LargeMonthly.price)
                              )
                            ]),
                            _vm._v("/mth "),
                            _c("br"),
                            _c("span", { staticClass: "is-size-6" }, [
                              _vm._v("or")
                            ]),
                            _c("br"),
                            _vm._v("$"),
                            _c("b", [
                              _vm._v(
                                _vm._s(_vm.$root.newPlans.LargeYearly.price)
                              )
                            ]),
                            _vm._v("/yr")
                          ]
                        ),
                        _vm._v(" "),
                        _c("br")
                      ])
                    ])
                  ])
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "has-text-white is-size-4 has-text-centered top20" },
            [
              _c("b", [
                _vm._v("Your account may hold as many Slinks as you like")
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "has-text-white is-size-5 has-text-centered top10" },
            [
              _vm._v(
                "*Please contact us for corporate plans with higher subslink counts"
              )
            ]
          ),
          _vm._v(" "),
          _c("br")
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "uses",
          staticClass: "iconsDivContainer",
          attrs: { id: "uses" }
        },
        [
          _c("div", { staticClass: "container" }, [
            _c(
              "div",
              { staticClass: "is-size-2 has-text-petBlue has-text-left top80" },
              [
                _c("img", {
                  attrs: {
                    src: require("@/assets/img/chevronsY.png"),
                    width: "30"
                  }
                }),
                _c("b", { staticClass: "left3" }, [_vm._v("Some use cases")])
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "top20 is-size-5" }, [
              _vm._v(
                "Slinks have the unique ability to inject meaning into often cryptic URLs.  The combination of a strong slink word and its subslinks, provides a powerful tool to dramatically increase recall, brand recongnition and traffic. Below are some examples of how slinks and subslinks can be used."
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "columns top60 left10" }, [
              _c("div", { staticClass: "column" }, [
                _c("div", { staticClass: "pad20" }, [
                  _c("div", { staticClass: "has-text-yell  top40" }, [
                    _c("i", { staticClass: "fa fa-bullseye fa-3x" })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "useCard top20" }, [
                    _c("div", { staticClass: "is-size-4 has-text-petBlue" }, [
                      _c("b", [
                        _vm._v("Make your website more easily accessible")
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "top5" }, [
                      _vm._v(
                        "Domain names can be difficult to remember and spell. With a slink that describes what your website is about, it will be easy for people to "
                      ),
                      _c("b", [
                        _vm._v("remember how to reach it again and again.")
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "top10" }, [
                    _vm._v(
                      '\n                            For example, the dog rescue organization, "Houston K-911 Rescue", uses the slink:\n                        '
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "top10" }, [
                    _c("img", {
                      attrs: {
                        src: require("@/assets/img/chevronsT.png"),
                        width: "18"
                      }
                    }),
                    _c("span", { staticClass: "is-size-5" }, [
                      _vm._v("slink.com/"),
                      _c("b", { staticClass: "has-text-turk" }, [
                        _vm._v("dogrescue")
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "top10" }, [
                    _vm._v(
                      "\n                           to ensure that they stay top-of-mind in people looking for their type of services. "
                    ),
                    _c("b", [
                      _vm._v(
                        "Their website can be reached just by remembering what it is about."
                      )
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "column lightBG" }, [
                _c("div", { staticClass: "pad20" }, [
                  _c("div", { staticClass: "has-text-yell  top40" }, [
                    _c("i", { staticClass: "fa-solid fa-users-gear fa-3x" })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "useCard top20" }, [
                    _c("div", { staticClass: "is-size-4 has-text-petBlue" }, [
                      _c("b", [
                        _vm._v("Simplify long URLs such as affiliate links")
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "top5" }, [
                      _vm._v("If you have a podcast or are an influencer, "),
                      _c("b", [
                        _vm._v(
                          "maximizing the recall of sponsors' calls-to-action and your affiliate links is critical to your bottom line."
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "top10" }, [
                    _vm._v(
                      "\n                            Affiliate links are an example of notoriously clunky URLs to convey. Using a catalog of subslinks to simplify and organize them provides an effective way for your audience to remember and access them. The following format is very effective:\n                        "
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "top10" }, [
                    _c("img", {
                      attrs: {
                        src: require("@/assets/img/chevronsT.png"),
                        width: "18"
                      }
                    }),
                    _c("span", { staticClass: "is-size-5" }, [
                      _vm._v("slink.com/"),
                      _c("b", { staticClass: "has-text-turk" }, [
                        _vm._v("[podcast name]:[brand 1]")
                      ])
                    ]),
                    _c("br"),
                    _vm._v(" "),
                    _c("img", {
                      attrs: {
                        src: require("@/assets/img/chevronsT.png"),
                        width: "18"
                      }
                    }),
                    _c("span", { staticClass: "is-size-5" }, [
                      _vm._v("slink.com/"),
                      _c("b", { staticClass: "has-text-turk" }, [
                        _vm._v("[podcast name]:[brand 2]")
                      ])
                    ]),
                    _c("br"),
                    _vm._v(" "),
                    _c("b", { staticClass: "has-text-turk" }, [_vm._v("...")])
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "columns  left10" }, [
              _c("div", { staticClass: "column  lightBG" }, [
                _c("div", { staticClass: "pad20" }, [
                  _c("div", { staticClass: "has-text-yell top40" }, [
                    _c("i", { staticClass: "fa-solid fa-phone-volume fa-3x" })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "useCard top20" }, [
                    _c("div", { staticClass: "is-size-4 has-text-petBlue" }, [
                      _c("b", [_vm._v("Share contact info effectively")])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "top5" }, [
                      _vm._v(
                        "Share your telephone number, email address, social media profile or any other contact information "
                      ),
                      _c("b", [
                        _vm._v('using a link that "says" what it does.')
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "top10" }, [
                    _vm._v(
                      "\n                            For example,\n                        "
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "top10" }, [
                    _c("img", {
                      attrs: {
                        src: require("@/assets/img/chevronsT.png"),
                        width: "18"
                      }
                    }),
                    _c("span", { staticClass: "is-size-5" }, [
                      _vm._v("slink.com/"),
                      _c("b", { staticClass: "has-text-turk" }, [
                        _vm._v("john:email")
                      ])
                    ]),
                    _c("br"),
                    _vm._v(" "),
                    _c("img", {
                      attrs: {
                        src: require("@/assets/img/chevronsT.png"),
                        width: "18"
                      }
                    }),
                    _c("span", { staticClass: "is-size-5" }, [
                      _vm._v("slink.com/"),
                      _c("b", { staticClass: "has-text-turk" }, [
                        _vm._v("mycompany:zoom")
                      ])
                    ]),
                    _c("br"),
                    _vm._v(" "),
                    _c("img", {
                      attrs: {
                        src: require("@/assets/img/chevronsT.png"),
                        width: "18"
                      }
                    }),
                    _c("span", { staticClass: "is-size-5" }, [
                      _vm._v("slink.com/"),
                      _c("b", { staticClass: "has-text-turk" }, [
                        _vm._v("mycompany:paypal")
                      ])
                    ]),
                    _c("br"),
                    _vm._v(" "),
                    _c("img", {
                      attrs: {
                        src: require("@/assets/img/chevronsT.png"),
                        width: "18"
                      }
                    }),
                    _c("span", { staticClass: "is-size-5" }, [
                      _vm._v("slink.com/"),
                      _c("b", { staticClass: "has-text-turk" }, [
                        _vm._v("insurance:call")
                      ])
                    ]),
                    _c("br"),
                    _vm._v(" "),
                    _c("img", {
                      attrs: {
                        src: require("@/assets/img/chevronsT.png"),
                        width: "18"
                      }
                    }),
                    _c("span", { staticClass: "is-size-5" }, [
                      _vm._v("slink.com/"),
                      _c("b", { staticClass: "has-text-turk" }, [
                        _vm._v("myliveshow:phone")
                      ])
                    ]),
                    _c("br"),
                    _vm._v(" "),
                    _c("img", {
                      attrs: {
                        src: require("@/assets/img/chevronsT.png"),
                        width: "18"
                      }
                    }),
                    _c("span", { staticClass: "is-size-5" }, [
                      _vm._v("slink.com/"),
                      _c("b", { staticClass: "has-text-turk" }, [
                        _vm._v("myrestaurant:order")
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "top10" }, [
                    _vm._v(
                      "\n                        Yes, slinks can even point to telephone numbers.\n                        "
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "column" }, [
                _c("div", { staticClass: "pad20" }, [
                  _c("div", { staticClass: "has-text-yell  top40" }, [
                    _c("i", { staticClass: "fa-solid fa-arrows-to-dot fa-3x" })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "useCard top20" }, [
                    _c("div", { staticClass: "is-size-4 has-text-petBlue" }, [
                      _c("b", [
                        _vm._v("Make your Slink the hub of your operation")
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "top5" }, [
                      _vm._v(
                        "Many influencers prefer not to have a website, posting all their content on social media platforms.  This can lead to brand fragmentation as the URLs they promote do not share a common domain or structure. Gathering analytics also becomes unwieldly"
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "top10" }, [
                    _vm._v(
                      "\n                            Using a slink and its subslinks to create a logical, branded catalog of links can be a "
                    ),
                    _c("b", [
                      _vm._v(
                        "powerful way to generate more engagement and recognition."
                      )
                    ]),
                    _vm._v(" Eg:\n                        ")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "top10" }, [
                    _c("img", {
                      attrs: {
                        src: require("@/assets/img/chevronsT.png"),
                        width: "18"
                      }
                    }),
                    _c("span", { staticClass: "is-size-5" }, [
                      _vm._v("slink.com/"),
                      _c("b", { staticClass: "has-text-turk" }, [
                        _vm._v("myhandle:featuredpost")
                      ]),
                      _c("b")
                    ]),
                    _c("br"),
                    _vm._v(" "),
                    _c("img", {
                      attrs: {
                        src: require("@/assets/img/chevronsT.png"),
                        width: "18"
                      }
                    }),
                    _c("span", { staticClass: "is-size-5" }, [
                      _vm._v("slink.com/"),
                      _c("b", { staticClass: "has-text-turk" }, [
                        _vm._v("myhandle:follow")
                      ]),
                      _c("b")
                    ]),
                    _c("br"),
                    _vm._v(" "),
                    _c("img", {
                      attrs: {
                        src: require("@/assets/img/chevronsT.png"),
                        width: "18"
                      }
                    }),
                    _c("span", { staticClass: "is-size-5" }, [
                      _vm._v("slink.com/"),
                      _c("b", { staticClass: "has-text-turk" }, [
                        _vm._v("myhandle:makeup")
                      ]),
                      _c("b")
                    ]),
                    _c("br"),
                    _vm._v(" "),
                    _c("img", {
                      attrs: {
                        src: require("@/assets/img/chevronsT.png"),
                        width: "18"
                      }
                    }),
                    _c("span", { staticClass: "is-size-5" }, [
                      _vm._v("slink.com/"),
                      _c("b", { staticClass: "has-text-turk" }, [
                        _vm._v("myhandle:playlist")
                      ]),
                      _c("b")
                    ]),
                    _c("br"),
                    _vm._v(" "),
                    _c("b", { staticClass: "has-text-turk" }, [_vm._v("...")])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "top10" }, [
                    _vm._v(
                      "\n                            Use the SlinkPage to display them all. You also get analytics for each slink and subslink.\n                        "
                    )
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "columns  left10" }, [
              _c("div", { staticClass: "column" }, [
                _c("div", { staticClass: "pad20" }, [
                  _c("div", { staticClass: "has-text-yell  top40" }, [
                    _c("i", { staticClass: "fa-regular fa-lightbulb fa-3x" })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "useCard top20" }, [
                    _c("div", { staticClass: "is-size-4 has-text-petBlue" }, [
                      _c("b", [_vm._v("Replace awkward QR Codes")])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "top5" }, [
                      _vm._v(
                        "A QR code must be visible to be useful. Using QR codes in situations where they are only briefly visible, such as in TV commercials is ineffective, especially if the user is actually watching the content on their phone!"
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "top10" }, [
                    _vm._v(
                      "\n                            Providing either a slink or a slink-generated QR code (which shows the actual slink below the code) is a "
                    ),
                    _c("b", [
                      _vm._v(
                        "much more effective way to direct traffic to a URL"
                      )
                    ]),
                    _vm._v(
                      ". The slink will be remembered and can be accessed at any time in the future. Plus, you can change the target URL without having to reprint the QR code. Eg:\n                        "
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "top10" }, [
                    _c("img", {
                      attrs: {
                        src: require("@/assets/img/tutto.png"),
                        width: "200"
                      }
                    })
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "column  lightBG" }, [
                _c("div", { staticClass: "pad20" }, [
                  _c("div", { staticClass: "has-text-yell  top40" }, [
                    _c("i", { staticClass: "fa-solid fa-bars fa-3x" })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "useCard top20" }, [
                    _c("div", { staticClass: "is-size-4 has-text-petBlue" }, [
                      _c("b", [_vm._v("Create a menu of service links")])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "top5" }, [
                      _vm._v(
                        "Sifting through search engine results is cumbersome and exposes your audience to potential competitors."
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "top10" }, [
                    _vm._v(
                      "\n                            With a slink and subslinks you can create logical links for each of the services you offer, "
                    ),
                    _c("b", [
                      _vm._v(
                        "once your audience sees or hears them once, they'll remember how to access them."
                      )
                    ]),
                    _vm._v(" Eg:\n                        ")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "top10" }, [
                    _c("img", {
                      attrs: {
                        src: require("@/assets/img/chevronsT.png"),
                        width: "18"
                      }
                    }),
                    _c("span", { staticClass: "is-size-5" }, [
                      _vm._v("slink.com/"),
                      _c("b", { staticClass: "has-text-turk" }, [
                        _vm._v("myrestaurant")
                      ])
                    ]),
                    _c("br"),
                    _vm._v(" "),
                    _c("img", {
                      attrs: {
                        src: require("@/assets/img/chevronsT.png"),
                        width: "18"
                      }
                    }),
                    _c("span", { staticClass: "is-size-5" }, [
                      _vm._v("slink.com/"),
                      _c("b", { staticClass: "has-text-turk" }, [
                        _vm._v("myrestaurant:menu")
                      ])
                    ]),
                    _c("br"),
                    _vm._v(" "),
                    _c("img", {
                      attrs: {
                        src: require("@/assets/img/chevronsT.png"),
                        width: "18"
                      }
                    }),
                    _c("span", { staticClass: "is-size-5" }, [
                      _vm._v("slink.com/"),
                      _c("b", { staticClass: "has-text-turk" }, [
                        _vm._v("myrestaurant:order")
                      ])
                    ]),
                    _c("br"),
                    _vm._v(" "),
                    _c("img", {
                      attrs: {
                        src: require("@/assets/img/chevronsT.png"),
                        width: "18"
                      }
                    }),
                    _c("span", { staticClass: "is-size-5" }, [
                      _vm._v("slink.com/"),
                      _c("b", { staticClass: "has-text-turk" }, [
                        _vm._v("myrestaurant:reservations")
                      ])
                    ]),
                    _c("br"),
                    _vm._v(" "),
                    _c("img", {
                      attrs: {
                        src: require("@/assets/img/chevronsT.png"),
                        width: "18"
                      }
                    }),
                    _c("span", { staticClass: "is-size-5" }, [
                      _vm._v("slink.com/"),
                      _c("b", { staticClass: "has-text-turk" }, [
                        _vm._v("myrestaurant:location")
                      ])
                    ]),
                    _c("br"),
                    _vm._v(" "),
                    _c("b", { staticClass: "has-text-turk" }, [_vm._v("...")])
                  ])
                ])
              ])
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "stats mobileMargin" }, [
        _c("div", [
          _c("div", {}, [
            _c("br"),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "container leftDotted   top80",
                attrs: { "data-aos": "fade-right" }
              },
              [
                _c("div", { staticClass: "left20 " }, [
                  _c("br"),
                  _c("br"),
                  _c("br"),
                  _vm._v(" "),
                  _c("div", { staticClass: "is-size-3 has-text-yell" }, [
                    _c("img", {
                      attrs: {
                        src: require("@/assets/img/chevronsT.png"),
                        width: "30"
                      }
                    }),
                    _c("b", [_vm._v(" Some facts you may already know")])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "is-size-4 top40" }, [
                    _c("div", { staticClass: "top20" }, [
                      _vm._v(
                        "\n                                    The OOH Advertising Industry will reach "
                      ),
                      _c("b", [_vm._v("$26 billion in spending")]),
                      _vm._v("  in 2023\n                                ")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "top20" }, [
                      _vm._v(
                        "\n                                    Audio ads is the "
                      ),
                      _c("b", [_vm._v("fastest-growing segment")]),
                      _vm._v(
                        " in advertising\n                                "
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "top20" }, [
                      _vm._v(
                        "\n                                   +50% of audio ads are  "
                      ),
                      _c("b", [_vm._v("read by the show's host")])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "top20" }, [
                      _vm._v(
                        "\n                                    Digital Audio Advertising spending is projected to reach "
                      ),
                      _c("b", [_vm._v("$8.95 billion")]),
                      _vm._v(" in 2023.\n                                ")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "top20" }, [
                      _c("b", [_vm._v("50% of millennials listen to audio")]),
                      _vm._v(
                        " while doing other things like cooking, cleaning, driving and excercising\n                                "
                      )
                    ]),
                    _vm._v(" "),
                    _c("br"),
                    _c("br")
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "button is-yell top20 has-text-dark",
                      on: {
                        click: function($event) {
                          return _vm.$router.push("/get")
                        }
                      }
                    },
                    [_c("b", [_vm._v("START SLINKING")])]
                  )
                ])
              ]
            )
          ])
        ]),
        _vm._v(" "),
        _c("br"),
        _vm._v(" "),
        _c("br")
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5a90ec03", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a90ec03","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Home.vue
// module id = null
// module chunks = 